import { AlarmTypeGroupFilters } from '@hakimo-ui/hakimo/types';
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const pageAtom = atom<number>(1);
export const pageSizeAtom = atom<number>(20);
export const filtersAtom = atomWithStorage<AlarmTypeGroupFilters>(
  'alarmTypeGroups/filters',
  { name: { values: [], negative: false } }
);
